import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Support from '@/views/Support'
import Hunting from '@/views/Hunting'
import Item from '@/views/Item'
import Revenge from '@/views/Revenge'
import World from '@/views/World'
import store from '@/store/store'

Vue.use(Router)

const router =  new Router({
  routes: [
      {
        path: '/home',
        name: 'home',
        component: Home
      },
      {
          path: '/support',
          name: 'support',
          component: Support
      },
      {
        path: '/hunting',
        name: 'hunting',
        component: Hunting
      },
      {
          path: '/item',
          name: 'item',
          component: Item
      },
      {
          path: '/revenge',
          name: 'revenge',
          component: Revenge
      },
      {
          path: '/world',
          name: 'world',
          component: World
      },
    { path: '*', component: Home }
  ]
})
router.beforeEach((to, from, next) => {
  if(store.state.isMovePage)return;
  if(store.state.isLayerView)return;
  next();
})

export default router
